module.exports = __webpack_public_path__ + "img/google_analytics-horizontal.c178bde8.svg";